import { forwardRef, memo, type PropsWithChildren } from 'react';

import { TABLE_CELL_FULL_ROW_COL_SPAN } from '../../constants.ts';
import { TableCellInnerContent, TableCellInnerTitle, TableCellInnerWrapper, TableCellWrapper } from './styled.ts';
import type { TableCellProps } from './types.ts';

export const TableCell = memo(
  forwardRef<HTMLTableCellElement, PropsWithChildren<TableCellProps>>(function TableCell(
    { children, className, title, fullRow, dataTestId, ...props },
    ref,
  ) {
    return (
      <TableCellWrapper
        {...props}
        className={className}
        colSpan={fullRow && !props.colSpan ? TABLE_CELL_FULL_ROW_COL_SPAN : props.colSpan}
        ref={ref}
        data-content-type={props.contentType}>
        <TableCellInnerWrapper {...props}>
          {title && <TableCellInnerTitle>{title}</TableCellInnerTitle>}
          <TableCellInnerContent $contentType={props.contentType} data-testid={dataTestId}>
            {children}
          </TableCellInnerContent>
        </TableCellInnerWrapper>
      </TableCellWrapper>
    );
  }),
);
